import React, { memo, useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { useTranslation } from 'react-i18next';
import { configuration } from '../config/main.config';
import { Grid } from '@mui/material';


function CustomGoogleMap(props) {
    const { children, center, zoom, onClick, onChange } = props;
    const [initialRegion, setInitialRegion] = useState({ lat: -34.1664276, lng: 16.6257506 });
    const { t } = useTranslation();
    var centerRegion = initialRegion
    if (center) {
        centerRegion = { lat: center.lat, lng: center.lng }
    }

    return (
        <Grid item xs={12} width={'100%'} height={'100%'}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: document._portalConfig.apiKeyMap }}
                defaultZoom={10}
                defaultCenter={initialRegion}
                center={centerRegion}
                zoom={zoom}
                onChange={onChange}
                onClick={onClick}
                onDragEnd={(map) => {
                    console.log("AAAA onDragEnd map: ", map)
                    console.log("AAAA onDragEnd lat: ", map.center.lat())
                    console.log("AAAA onDragEnd lng: ", map.center.lng())
                }}
            >
                {children}
            </GoogleMapReact>
        </Grid>
    );
}

export default memo(CustomGoogleMap)